"use client";

import { STORE_KEYS, WAITFREE_INTRO_SHOWN_KEY } from "app/constants";
import { useStaticStore } from "app/hooks";
import { MdClose } from "react-icons/md";
import { WaitFreeIntroImage } from "./SVGImages";
import { EpisodeModel } from "@api/models";
import Dialog from "./Dialog";
import { useEffect, useSyncExternalStore } from "react";
import { sessionStore } from "@lib/sessionStore";
import { EpisodeAccessAccessTypeEnum } from "@api/models/EpisodeAccess";

function savePopupShown() {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(WAITFREE_INTRO_SHOWN_KEY, "1");
  }
}

export function PopupWaitFreeIntro({ episode }: { episode: EpisodeModel }) {
  //session
  const { sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );
  //待つと無料の案内dialogの表示非表示
  let isWaitFreeIntroShown: string | null = null;

  if (typeof window !== "undefined") {
    isWaitFreeIntroShown = window.localStorage.getItem(WAITFREE_INTRO_SHOWN_KEY);
  }
  const shouldOpenWaitFreeIntro =
    !isWaitFreeIntroShown &&
    episode.access.accessType === EpisodeAccessAccessTypeEnum.WaitAndFree &&
    !episode.series.waitAndFreeRecoveryTime;

  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.waitFreeIntroPopup);

  const handleClose = () => {
    //一度表示したら表示しない
    savePopupShown();
    setIsOpen(false);
  };

  useEffect(() => {
    if (sessionStatus === "authenticated" && shouldOpenWaitFreeIntro) {
      setIsOpen(true);
    } else {
      // do nothing
    }
  }, [sessionStatus]);

  return (
    <>
      {shouldOpenWaitFreeIntro && (
        <Dialog
          storeKey={STORE_KEYS.waitFreeIntroPopup}
          className={"mode-waitfree-intro"}
          onClosedByClickOutside={savePopupShown}
        >
          <div className="dialog-content">
            <div className="dialog-main">
              <h2 className="dialog-h">
                <strong className="dialog-h-strong mode-waitfree">「待つと無料」</strong>の作品は
                <br />
                毎日、何作品でも無料で読めます
              </h2>
              <p className="dialog-desc">
                23時間待って「チャージ済」になると
                <br />
                次の話を無料で読めます
              </p>
              <figure className="dialog-main-fig mode-waitfree">
                <WaitFreeIntroImage className="dialog-main-img" />
              </figure>
            </div>
            <div className="dialog-f">
              <button className="dialog-f-btn" onClick={handleClose} autoFocus>
                閉じる
              </button>
            </div>
            <button className="dialog-close" onClick={handleClose}>
              <MdClose aria-label="閉じる" size={24} className="dialog-close-icon" />
            </button>
          </div>
        </Dialog>
      )}
    </>
  );
}
